<div *ngIf="render" [style]="style">
  <sigv-input-text
    [fieldName]="fieldName"
    [bindingFormControl]="bindingFormControl"
    [isReadOnly]="isReadOnly"
    [style]="maxlength ? { width: useWidth } : {}"
    [isPostfixMark]="oldIdentityNo ? true : false"
    (blur)="blurEvent($event)"
    style="width:'{{ useWidth }}' !important"
  ></sigv-input-text>
  <i
    *ngIf="
      oldIdentityNo && oldIdentityNo !== this.bindingFormControl?.getRawValue()
    "
    class="oldId pi pi-warning p-mr-2"
    [pTooltip]="tooltipMessage"
  ></i>
</div>
